export enum locationTypeEnum {
    country,
    city,
    property,
    pincode
  }